module.exports = __webpack_public_path__ + "img/harmony-03012025.40b35940.jpg";